import React, { FC } from 'react';

interface ILeftNavigation {
  className: string;
}
const LeftNavigation: FC<ILeftNavigation> = (props) => (
  <svg
    {...props}
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.00609 10.0573C7.84719 10.8984 6.54344 12.1595 5.745 11.3184L0.994244 6.56759C0.61581 6.23127 0.61581 5.64282 0.994244 5.3065L5.61858 0.640017C6.45967 -0.158963 7.72082 1.10267 6.87967 1.94322L2.8859 5.937L7.00609 10.0573Z" />
  </svg>
);

export default LeftNavigation;
